import { render, staticRenderFns } from "./SocialSecurityContributions.vue?vue&type=template&id=c5f70230&scoped=true&"
import script from "./SocialSecurityContributions.vue?vue&type=script&lang=js&"
export * from "./SocialSecurityContributions.vue?vue&type=script&lang=js&"
import style0 from "./SocialSecurityContributions.vue?vue&type=style&index=0&id=c5f70230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f70230",
  null
  
)

export default component.exports